
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Alert from 'vux/src/components/alert/index.vue'


const dataList = [{
src:"",
state:"",
name:"",
money:""
}];
export default {
components: {
Swiper,
Divider,
Alert
},
data () {
return{
editSkuInfo:{
listQuery: Object.assign({}, dataList)
},
swiperIndex: 0,
isShow:false,
model:{demandId : this.$route.query.demandId},
list:{},
img:[],
show:false,
message:""
}
},
created(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mdemand/getDetail',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.list=res.body.data;
if( this.list.demandDesc != undefined){
this.list.demandDesc=  this.list.demandDesc.replace(/style="[^"]*?"/g,'');
this.list.demandDesc= this.list.demandDesc.replace(/height="[^"]*?"/g,'');
this.list.demandDesc= this.list.demandDesc.replace(/width="[^"]*?"/g,'');
this.list.demandDesc= this.list.demandDesc.replace(/img/g,'img width="100%" ');
}
for(var i=0;i<res.body.data.demandImageLs.length;i++){
this.img.push(res.body.data.demandImageLs[i].image);
}

}
},function(res){
console.log(res.status);
});
},
methods: {
goBack(){
app.goBack();

},
call(){
app.callPhone("400-887-4949");
},
swiperChange (index) {
this.swiperIndex = index
},
ShowColler(){
this.show=true
this.message="手机端暂不支持此功能。请移步至PC端操作"
}
}
}



// WEBPACK FOOTER //
// ./src/views/ntalk/mall/demand/detail.vue